module.exports = __webpack_public_path__ + "static/media/Apple iPhone SE Gold.16e4ffae.png";